import script from "./CatalogCategoryView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogCategoryView.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogCategoryView.vue?vue&type=style&index=0&id=219671a7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-219671a7"]])

export default __exports__